const listaVinos = [
  {
    DIA: 'DÍA 1',
    VINOS: {
      vino: 'Albarin',
      lugar: 'D.O. Tierra de León DOP',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Albarin_2018.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/vino-albarin?_pos=1&_sid=0858b380b&_ss=r',
    VIDEO: 'https://www.youtube.com/embed/5KTsGpOA-Zg?si=u-VDHpbxy23bxAy-',
    VIDEO_EN: 'https://www.youtube.com/embed/zkZxvpCkZ9g?si=lfDvQGjFYgycxfe1',
  },
  {
    DIA: 'DÍA 2',
    VINOS: {
      vino: 'Graciano',
      lugar: 'Castilla La Mancha',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ACFrOgCYm6oj2sVOwR7ufbiY3M2nJX6wjlHYV52T7mnqWWuo3u_mg98L39usSBDKBnhFTF-E_xZtcHxn_9IsnU4JBvt6Scg0YjLwtMsQl26pTcv_x84ke4Zs94g8S_j6bn-Ck511lQaAxqaT.pdf?v=1668055055',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-graciano?_pos=1&_psq=GRACIANO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/T9v1XjOt-Q0?si=IVtvIQUzqS8fSzaC',
    VIDEO_EN: 'https://www.youtube.com/embed/v3SzNOZ-Dtg?si=wTXUmeOcols9MmJT',
  },
  {
    DIA: 'DÍA 3',
    VINOS: {
      vino: 'Treixadura',
      lugar: 'Sierra de Salamanca',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'NO ESTÁ EN TIENDA',
    },
    LINK_TIENDA: '',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/lCHJbxpdt0I?si=o9Z5MnGbOB1M0kbD',
    VIDEO_EN: 'https://www.youtube.com/embed/CuVFD4FiYiU?si=BVJGKU2lM0nxQjGz',
  },
  {
    DIA: 'DÍA 4',
    VINOS: {
      vino: 'Garnacha',
      lugar: 'D.O. Calatayud',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Garnacha_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-garnacha?_pos=1&_psq=GARNACHA&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/dWFKRZu8fzA?si=R6qg3ULketFv2Aom',
    VIDEO_EN: 'https://www.youtube.com/embed/504gqNycAMc?si=g6cvz9kPFe6LUXqe',
  },
  {
    DIA: 'DÍA 5',
    VINOS: {
      vino: 'Mazuela',
      lugar: 'D.O. Cariñena',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'PENDIENTE SUBIR A TIENDA CON SU FICHA',
    },
    LINK_TIENDA: 'https://raicesibericas.com/products/raices-bobal-1',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/Dvu3KB8f-K0?si=qMqXcqIqr1wBZUzF',
    VIDEO_EN: 'https://www.youtube.com/embed/QQeo3nRbHv4?si=FOvF7JjhCyN9k5-x',
  },
  {
    DIA: 'DÍA 6',
    VINOS: {
      vino: 'Juan García',
      lugar: 'D.O. Arribes',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://raicesibericas.com/products/raices-juan-garcia?_pos=1&_psq=JUAN&_ss=e&_v=1.0',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-juan-garcia?_pos=1&_psq=JUAN&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/vlahlibjkKE?si=v9CVjH5fMYTNHf_k',
    VIDEO_EN: 'https://www.youtube.com/embed/wKlTUhvpeXw?si=zDLcCBlpxU38412s',
  },
  {
    DIA: 'DÍA 7',
    VINOS: {
      vino: 'Monastrell',
      lugar: 'D.O.P. Jumilla',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Fiche_technique_Monastrell_2021.pdf?v=1673622635',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-monastrell?_pos=1&_psq=MONAS&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/RqpdZ6iSyIs?si=o6kSRaS4VOcNxxrO',
    VIDEO_EN: 'https://www.youtube.com/embed/5dgUmStzUJc?si=r3IPpkSU-IqAUziV',
  },
  {
    DIA: 'DÍA 8',
    VINOS: {
      vino: 'Bruñal',
      lugar: 'Arribes del Duero',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'ESTE VINO SOLO ESTARÁ EN LA TIENDA FÍSICA NO ONLINE',
    },
    LINK_TIENDA: '',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/rtkFF7YcZnY?si=09xjMHM13iFBetKJ',
    VIDEO_EN: 'https://www.youtube.com/embed/PQhaCWljR-s?si=ri-Zgilu2yTfTWYn',
  },
  {
    DIA: 'DÍA 9',
    VINOS: {
      vino: 'Eva',
      lugar: 'D.O. Campo de Borja',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica: '',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-moscatel?_pos=1&_psq=MOSCATE&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/ZQIdOHBalqI?si=3GhYsrSmbrA_GXEo',
    VIDEO_EN: 'https://www.youtube.com/embed/cPPQJs1vYXM?si=MvpWxZ1o4Uiorp12',
  },
  {
    DIA: 'DÍA 10',
    VINOS: {
      vino: 'Mencía',
      lugar: 'D.O. Bierzo',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Mencia_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-mencia?_pos=1&_psq=MENCIA&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/FRjOhaTMJl4?si=KJ32rdqr9MPnKiDj',
    VIDEO_EN: 'https://www.youtube.com/embed/cup0E7BS_bY?si=tZez0Nf0NYsd46Hm',
  },
  {
    DIA: 'DÍA 11',
    VINOS: {
      vino: 'Xarel-lo',
      lugar: 'D.O. Tarragona',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Xarel-lo_2018.pdf?v=1673708375',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-xarel-lo?_pos=1&_psq=XARE-LO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/WM47NTNin2A?si=n0LEGPvdnCVqNN4p',
    VIDEO_EN: 'https://www.youtube.com/embed/5kl9nEHmyQI?si=NctG4dxqWkKNyJ0y',
  },
  {
    DIA: 'DÍA 12',
    VINOS: {
      vino: 'Albillo',
      lugar: 'Vino de la Tierra de Castilla y León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Albillo_2021_1.pdf?v=1673622808',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-albillo?_pos=1&_psq=ALBILL&_ss=e&_v=1.0',
    VIDEO: 'https://www.youtube.com/embed/4KEsMlnCj8c?si=0QugiGMS9xCfL_8d',
    VIDEO_EN: 'https://www.youtube.com/embed/a-bghKr0lEI?si=TPHdC73-JAjHtNHF',
  },

  {
    DIA: 'DÍA 13',
    VINOS: {
      vino: 'Tempranillo',
      lugar: 'D.O. Calatayud',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Tempranillo_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-tempranillo?_pos=1&_psq=TEMPR&_ss=e&_v=1.0',
    VIDEO: 'https://www.youtube.com/embed/edso9UHyOxE?si=6mfBjXz_wzhlTVeQ',
    VIDEO_EN: 'https://www.youtube.com/embed/-gzr6vRMEiw?si=xvLCP3eXFeZ0G6mg',
  },
  {
    DIA: 'DÍA 14',
    VINOS: {
      vino: 'Hondarrabi Zuri',
      lugar: 'D.O. Rías Baixas',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Albarino_2018.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-albarino?_pos=1&_sid=935fa37e0&_ss=r',
    VIDEO: 'https://www.youtube.com/embed/-oMp1VXoUFk?si=ub9vSmYV84G__4NX',
    VIDEO_EN: 'https://www.youtube.com/embed/4xBVydd1QG4?si=ybgKPWnQMfAG-Sf2',
  },
  {
    DIA: 'DÍA 15',
    VINOS: {
      vino: 'Verdejo',
      lugar: 'Vino de la Tierra de Castilla y León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Verdejo_2018.pdf?v=1667239661',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-verdejo?_pos=2&_psq=VER&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/TcXZbKeTS8s?si=qxVtpKbqWSyHyr_8',
    VIDEO_EN: 'https://www.youtube.com/embed/QYyeZqgLTc4?si=4aDS9DYYhs_JHKm1',
  },
  {
    DIA: 'DÍA 16',
    VINOS: {
      vino: 'Bobal',
      lugar: 'DOP Utiel-Requena',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Bobal_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-bobal?_pos=2&_psq=BOBAL&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/fV3-iDE0aEY?si=uClygz3FDOaZCmd6',
    VIDEO_EN: 'https://www.youtube.com/embed/K_Of_BjeVqg?si=RobYwoGtDFmCI9bU',
  },
  {
    DIA: 'DÍA 17',
    VINOS: {
      vino: 'Rufete',
      lugar: 'DOP Sierra de Salamanca',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Fiche_tecnica_Rufete_2017.pdf?v=1695105203',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-rufete?_pos=1&_sid=29d801f51&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/jFiY4xHh9N4?si=cUI3zmJ7_f3OykZP',
    VIDEO_EN: 'https://www.youtube.com/embed/ufjJxONZHNE?si=NwzH6wLRC5BfQK21',
  },
  {
    DIA: 'DÍA 18',
    VINOS: {
      vino: 'Godello',
      lugar: 'D.O. Bierzo',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Godello_2017.pdf?v=1667998223',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-godello?_pos=1&_sid=6da58279c&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/5piAZ2hpfRA?si=jl24q3i3GF3sKqI0',
    VIDEO_EN: 'https://www.youtube.com/embed/vT4iDx2uFLk?si=sxJHEM_Nm2T8ZVpP',
  },
  {
    DIA: 'DÍA 19',
    VINOS: {
      vino: 'Prieto Picudo',
      lugar: 'León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Prieto_Picudo_2021_1.pdf?v=1673612428',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-prieto-picudo?_pos=1&_psq=PRIETO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/dt6F0981Wq8?si=XCL1OH2eZGQaHrVa',
    VIDEO_EN: 'https://www.youtube.com/embed/x0AVQ0r_BVc?si=GREWC0y6k4f1fym5',
  },
  {
    DIA: 'DÍA 20',
    VINOS: {
      vino: 'Tintorera',
      lugar: 'Manchuela',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Tintorera_2017_4a134153-2676-461f-b5e1-6644150a1328.pdf?v=1668055205',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-tintorera?_pos=1&_sid=0c6fafc8e&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/HxB0q-s0a9w?si=Ue_uVrG6E3vvJu8K',
    VIDEO_EN: 'https://www.youtube.com/embed/WI43MuXDvok?si=2fDXm2Znx2bAL1S6',
  },
  {
    DIA: 'DÍA 21',
    VINOS: {
      vino: 'Garnacha Blanca',
      lugar: 'D.O. Terra Alta',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Garnacha_Blanca_2018.pdf?v=1667988698',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-garnacha-blanca?_pos=2&_psq=GARNACH&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/npVOsrUVayQ?si=FHp1IlPmPM_dwFK_',
    VIDEO_EN: 'https://www.youtube.com/embed/LY8O7fEoVGM?si=ijiv4ZRhOCwjR72B',
  },
  {
    DIA: 'DÍA 22',
    VINOS: {
      vino: 'Malvar',
      lugar: 'D.O. Vinos de Madrid',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Malvar_2018-2.pdf?v=1668170472',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-albarino-1?_pos=1&_sid=714220bb3&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/aAkajuQGxZs?si=eyK9LdUPKSZvuZcC',
    VIDEO_EN: 'https://www.youtube.com/embed/mbWu96uR7tE?si=bBQsJRS7poIMUgOL',
  },
  {
    DIA: 'DÍA 23',
    VINOS: {
      vino: 'Raíces 1 Blanco',
      lugar: 'D.O.',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_RAICES_1_Blanco_2017_9a28ff37-857c-440f-b2d1-03d1516ffbc1.pdf?v=1668055442',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-raices-1-blanco-1?_pos=1&_psq=RAICES+1+BL&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/wF5MdgSgFR8?si=zQxBds34-ooQzOLx',
    VIDEO_EN: 'https://www.youtube.com/embed/HlI9rhCyLfk?si=DcHTCP8goS2bRvAz',
  },
  {
    DIA: 'DÍA 24',
    VINOS: {
      vino: 'Raíces 1 Tinto',
      lugar: 'D.O.',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_RAICES_1_2016_81babe21-e9e3-4ff9-8d8e-6180be7ffff7.pdf?v=1668055542',
      labelCompra: 'Hazte con él',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-raices-1-blanco?_pos=1&_psq=RAICES+1+TIN&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/2nYyT0nRYfY?si=tfkkt6M2TU5acWdr',
    VIDEO_EN: 'https://www.youtube.com/embed/gYtTwqKj6YA?si=q_IAIq9zY3zVSbr_',
  },
];

const listaVinos2024 = [
  {
    DIA: 'DÍA 1',
    VINOS: {
      vino: 'Albarin',
      lugar: 'D.O. Tierra de León DOP',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Albarin_2018.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'Laura Mora Muñoz',
      sumilierEng: 'Laura Mora Muñoz',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/vino-albarin?_pos=1&_sid=0858b380b&_ss=r',
    VIDEO: 'https://www.youtube.com/embed/3-8D_Bd3OQQ',
    VIDEO_EN: 'https://www.youtube.com/embed/1hvN1pSHsjM',
  },
  {
    DIA: 'DÍA 2',
    VINOS: {
      vino: 'Graciano',
      lugar: 'Castilla La Mancha',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ACFrOgCYm6oj2sVOwR7ufbiY3M2nJX6wjlHYV52T7mnqWWuo3u_mg98L39usSBDKBnhFTF-E_xZtcHxn_9IsnU4JBvt6Scg0YjLwtMsQl26pTcv_x84ke4Zs94g8S_j6bn-Ck511lQaAxqaT.pdf?v=1668055055',
      labelCompra: 'Hazte con él',
      sumilier: 'Giorgia Scaramella',
      sumilierEng: 'Giorgia Scaramella',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-graciano?_pos=1&_psq=GRACIANO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/5s6xJjx1PoU',
    VIDEO_EN: 'https://www.youtube.com/embed/lQYhUtOiauM',
  },
  {
    DIA: 'DÍA 3',
    VINOS: {
      vino: 'Treixadura',
      lugar: 'Sierra de Salamanca',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'NO ESTÁ EN TIENDA',
      sumilier: 'Sergi Ruiz',
      sumilierEng: 'Sergi Ruiz',
    },
    LINK_TIENDA: '',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/m0hhmgmKBmw',
    VIDEO_EN: 'https://www.youtube.com/embed/O8GT7Nd7So4',
  },
  {
    DIA: 'DÍA 4',
    VINOS: {
      vino: 'Garnacha Tinta',
      lugar: 'D.O. Calatayud',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Garnacha_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'Karim Koulel',
      sumilierEng: 'Karim Koulel',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-garnacha?_pos=1&_psq=GARNACHA&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/_ttKyMACI8A',
    VIDEO_EN: 'https://www.youtube.com/embed/eOkWv1shmd4',
  },
  {
    DIA: 'DÍA 5',
    VINOS: {
      vino: 'Mazuela',
      lugar: 'D.O. Cariñena',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'Hazte con él',
      sumilier: 'Daphne Van Den Hoven',
      sumilierEng: 'Daphne Van Den Hoven',
    },
    LINK_TIENDA: 'https://raicesibericas.com/products/raices-bobal-1',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/4WryFn-yZ0E',
    VIDEO_EN: 'https://www.youtube.com/embed/kOGtTp3rVS4',
  },
  {
    DIA: 'DÍA 6',
    VINOS: {
      vino: 'Juan García',
      lugar: 'D.O. Arribes',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://raicesibericas.com/products/raices-juan-garcia?_pos=1&_psq=JUAN&_ss=e&_v=1.0',
      labelCompra: 'Hazte con él',
      sumilier: 'Marina Beltrame',
      sumilierEng: 'Marina Beltrame',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-juan-garcia?_pos=1&_psq=JUAN&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/-Oe4OOnnA6o',
    VIDEO_EN: 'https://www.youtube.com/embed/a2jC_QcsgZI',
  },
  {
    DIA: 'DÍA 7',
    VINOS: {
      vino: 'Monastrell',
      lugar: 'D.O.P. Jumilla',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Fiche_technique_Monastrell_2021.pdf?v=1673622635',
      labelCompra: 'Hazte con él',
      sumilier: 'Myoerik Depraetere',
      sumilierEng: 'Myoerik Depraetere',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-monastrell?_pos=1&_psq=MONAS&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/EyZ07hGkgKM',
    VIDEO_EN: 'https://www.youtube.com/embed/PhM9y847wO4',
  },
  {
    DIA: 'DÍA 8',
    VINOS: {
      vino: 'Bruñal',
      lugar: 'Arribes del Duero',
      fichaTecnicaLabel: 'NO HAY FICHA',
      linkFichaTecnica: '',
      labelCompra: 'ESTE VINO SOLO ESTARÁ EN LA TIENDA FÍSICA NO ONLINE',
      sumilier: 'Maria Girón',
      sumilierEng: 'Maria Girón',
    },
    LINK_TIENDA: '',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/Z3dnBajKLZg',
    VIDEO_EN: 'https://www.youtube.com/embed/H74pfc-H_W4',
  },
  {
    DIA: 'DÍA 9',
    VINOS: {
      vino: 'Eva',
      lugar: 'D.O. Campo de Borja',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica: '',
      labelCompra: 'Hazte con él',
      sumilier: 'Ferran Centelles',
      sumilierEng: 'Ferran Centelles',
    },
    LINK_TIENDA: '',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/vkGjPt_epzU',
    VIDEO_EN: 'https://www.youtube.com/embed/mhGIg4aS3OA',
  },
  {
    DIA: 'DÍA 10',
    VINOS: {
      vino: 'Mencía',
      lugar: 'D.O. Bierzo',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Mencia_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'Ruben Struyve',
      sumilierEng: 'Ruben Struyve',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-mencia?_pos=1&_psq=MENCIA&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/a6XAg6jUB28',
    VIDEO_EN: 'https://www.youtube.com/embed/999X-ylRroM',
  },
  {
    DIA: 'DÍA 11',
    VINOS: {
      vino: 'Xarel-lo',
      lugar: 'D.O. Tarragona',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Xarel-lo_2018.pdf?v=1673708375',
      labelCompra: 'Hazte con él',
      sumilier: 'Sevgi Tüzel - Conghaile',
      sumilierEng: 'Sevgi Tüzel - Conghaile',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-xarel-lo?_pos=1&_psq=XARE-LO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/emTj7upLECE',
    VIDEO_EN: 'https://www.youtube.com/embed/Tfke5oZeq2w',
  },
  {
    DIA: 'DÍA 12',
    VINOS: {
      vino: 'Albillo',
      lugar: 'Vino de la Tierra de Castilla y León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Albillo_2021_1.pdf?v=1673622808',
      labelCompra: 'Hazte con él',
      sumilier: 'Daniela Paz',
      sumilierEng: 'Daniela Paz',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-albillo?_pos=1&_psq=ALBILL&_ss=e&_v=1.0',
    VIDEO: 'https://www.youtube.com/embed/AKo6u2kmiIY',
    VIDEO_EN: 'https://www.youtube.com/embed/o6zEzb8LGT8',
  },

  {
    DIA: 'DÍA 13',
    VINOS: {
      vino: 'Tempranillo',
      lugar: 'D.O. Calatayud',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Tempranillo_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'Valerie Goedertier',
      sumilierEng: 'Valerie Goedertier',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-tempranillo?_pos=1&_psq=TEMPR&_ss=e&_v=1.0',
    VIDEO: 'https://www.youtube.com/embed/wcKVP_GSSRI',
    VIDEO_EN: 'https://www.youtube.com/embed/yu1RA6O1qhU',
  },
  {
    DIA: 'DÍA 14',
    VINOS: {
      vino: 'Hondarrabi Zuri',
      lugar: 'D.O. Rías Baixas',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Albarino_2018.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'Amaia Soto',
      sumilierEng: 'Amaia Soto',
    },
    LINK_TIENDA: '',
    VIDEO: 'https://www.youtube.com/embed/VGAjhL04Ffs',
    VIDEO_EN: 'https://www.youtube.com/embed/Q4cGJhERjFA',
  },
  {
    DIA: 'DÍA 15',
    VINOS: {
      vino: 'Verdejo',
      lugar: 'Vino de la Tierra de Castilla y León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Verdejo_2018.pdf?v=1667239661',
      labelCompra: 'Hazte con él',
      sumilier: 'Kenzo Lauwereins',
      sumilierEng: 'Kenzo Lauwereins',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-verdejo?_pos=2&_psq=VER&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/aJhSclJSZI4',
    VIDEO_EN: 'https://www.youtube.com/embed/lAPXJ04uH1g',
  },
  {
    DIA: 'DÍA 16',
    VINOS: {
      vino: 'Bobal',
      lugar: 'DOP Utiel-Requena',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Bobal_2017.pdf?v=1667998216',
      labelCompra: 'Hazte con él',
      sumilier: 'José Luis Simón',
      sumilierEng: 'José Luis Simón',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-bobal?_pos=2&_psq=BOBAL&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/f5zz4-5V72I',
    VIDEO_EN: 'https://www.youtube.com/embed/GzRGyvSnF5M',
  },
  {
    DIA: 'DÍA 17',
    VINOS: {
      vino: 'Rufete',
      lugar: 'DOP Sierra de Salamanca',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Fiche_tecnica_Rufete_2017.pdf?v=1695105203',
      labelCompra: 'Hazte con él',
      sumilier: 'Marla González',
      sumilierEng: 'Marla González',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-rufete?_pos=1&_sid=29d801f51&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/m9A8ZZFCDvw',
    VIDEO_EN: 'https://www.youtube.com/embed/3Cly1PKLRCc',
  },
  {
    DIA: 'DÍA 18',
    VINOS: {
      vino: 'Godello',
      lugar: 'D.O. Bierzo',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Godello_2017.pdf?v=1667998223',
      labelCompra: 'Hazte con él',
      sumilier: 'Shua Ibañez',
      sumilierEng: 'Shua Ibañez',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-godello?_pos=1&_sid=6da58279c&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/VIRPE_Mvvqc',
    VIDEO_EN: 'https://www.youtube.com/embed/snp_atewsXI',
  },
  {
    DIA: 'DÍA 19',
    VINOS: {
      vino: 'Prieto Picudo',
      lugar: 'León',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_Prieto_Picudo_2021_1.pdf?v=1673612428',
      labelCompra: 'Hazte con él',
      sumilier: 'Pieter Godts',
      sumilierEng: 'Pieter Godts',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-prieto-picudo?_pos=1&_psq=PRIETO&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/v-hMBtgjQrg',
    VIDEO_EN: 'https://www.youtube.com/embed/OwBaYH177bk',
  },
  {
    DIA: 'DÍA 20',
    VINOS: {
      vino: 'Tintorera',
      lugar: 'Manchuela',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Tintorera_2017_4a134153-2676-461f-b5e1-6644150a1328.pdf?v=1668055205',
      labelCompra: 'Hazte con él',
      sumilier: 'Nicolas Roché',
      sumilierEng: 'Nicolas Roché',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-tintorera?_pos=1&_sid=0c6fafc8e&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/5TP6wiTaOAs',
    VIDEO_EN: 'https://www.youtube.com/embed/ikTBZr9-e0c',
  },
  {
    DIA: 'DÍA 21',
    VINOS: {
      vino: 'Garnacha Blanca',
      lugar: 'D.O. Terra Alta',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Garnacha_Blanca_2018.pdf?v=1667988698',
      labelCompra: 'Hazte con él',
      sumilier: 'Daan De Maerteleire',
      sumilierEng: 'Daan De Maerteleire',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-garnacha-blanca?_pos=2&_psq=GARNACH&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/6GiP_x6AZwk',
    VIDEO_EN: 'https://www.youtube.com/embed/_2J03V_R3hc',
  },
  {
    DIA: 'DÍA 22',
    VINOS: {
      vino: 'Malvar',
      lugar: 'D.O. Vinos de Madrid',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RAICES_Malvar_2018-2.pdf?v=1668170472',
      labelCompra: 'Hazte con él',
      sumilier: 'Susana Bermudez y Pablo J. Poza',
      sumilierEng: 'Susana Bermudez y Pablo J. Poza',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-albarino-1?_pos=1&_sid=714220bb3&_ss=r',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/_WMzrFJWsh8',
    VIDEO_EN: 'https://www.youtube.com/embed/e4v8AfQ_vdk',
  },
  {
    DIA: 'DÍA 23',
    VINOS: {
      vino: 'Raíces 1 Blanco',
      lugar: 'D.O.',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_RAICES_1_Blanco_2017_9a28ff37-857c-440f-b2d1-03d1516ffbc1.pdf?v=1668055442',
      labelCompra: 'Hazte con él',
      sumilier: 'Juan Muñoz',
      sumilierEng: 'Juan Muñoz',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-raices-1-blanco-1?_pos=1&_psq=RAICES+1+BL&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/cXJKWZ4DglA',
    VIDEO_EN: 'https://www.youtube.com/embed/DzUiUgy5-Xs',
  },
  {
    DIA: 'DÍA 24',
    VINOS: {
      vino: 'Raíces 1 Tinto',
      lugar: 'D.O.',
      fichaTecnicaLabel: 'Ver ficha técnica',
      linkFichaTecnica:
        'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/Ficha_tecnica_RAICES_1_2016_81babe21-e9e3-4ff9-8d8e-6180be7ffff7.pdf?v=1668055542',
      labelCompra: 'Hazte con él',
      sumilier: 'Antonello Nicastri',
      sumilierEng: 'Antonello Nicastri',
    },
    LINK_TIENDA:
      'https://raicesibericas.com/products/raices-raices-1-blanco?_pos=1&_psq=RAICES+1+TIN&_ss=e&_v=1.0',
    COMENTARIO: '',
    VIDEO: 'https://www.youtube.com/embed/Wd07er4QXNc',
    VIDEO_EN: 'https://www.youtube.com/embed/kZfcyZTt7hE',
  },
];
function showCalendarModal() {
  let modalCalendar = document.getElementById('modal-advent-container');
  let buttonsCalendar = document.getElementsByClassName('modal-advent-btn');
  let buttonCalendarModal = document.getElementById(
    'modal-advent-modal-active-btn'
  );
  let closeIcon = document.getElementById('modal-advent-close-icon');
  let arrayButtonsCalendar = Array.from(buttonsCalendar);
  let modalTitleField = document.getElementById('modal-advent-title');
  let modalSumelier = document.getElementById('modal-advent-sumelier');
  let modalDescriptionField = document.getElementById(
    'modal-advent-description'
  );
  // let modalButton = document.getElementById("modal-advent-button");
  let modalButtonGold = document.getElementById('modal-advent-button-gold');
  let modalCommentField = document.getElementById('modal-comment-field');
  let modalVideo = document.querySelectorAll(
    '.modal-video-container video source'
  );
  var videoSource = document.getElementById('video-source');

  let modalVideoIframe = document.querySelectorAll(
    '.modal-video-container iframe'
  );
  var videoIframe = document.getElementById('video-iframe');
  let modalVideoIframeArray = Array.from(modalVideoIframe);
  let modalAviso = document.querySelector(
    '.modal-video-container .modal-aviso'
  );
  //let modalAviso = document.querySelectorAll(".modal-video-container .modal-aviso")
  //let modalAvisoArray = Array.from(modalAviso);
  let modalVideoClassIframe = document.getElementsByClassName(
    '.modal-video-container .modal-video'
  );

  const listaVinosActual =
    window.location.pathname === '/pages/adventcalendar' ||
    window.location.pathname === '/en/pages/adventcalendar'
      ? listaVinos2024
      : listaVinos;

  var currentUrl = window.location.pathname;
  var pageHandle = currentUrl.split('/').pop();

  arrayButtonsCalendar.forEach(btn => {
    btn.addEventListener('click', e => {
      const index = arrayButtonsCalendar.indexOf(btn);

      // Contenidos que vienen de la listaVinos
      modalTitleField.textContent =
        'Raíces Ibéricas |  ' + listaVinosActual[index].VINOS.vino;
      modalDescriptionField.textContent = listaVinosActual[index].VINOS.lugar;

      let lenguaje =
        window.location.href.indexOf('raicesibericas.com/en') != -1
          ? 'en'
          : 'es';

      const baseLink = listaVinosActual[index].LINK_TIENDA;
      const comentario = listaVinosActual[index].COMENTARIO;

      if (lenguaje === 'es') {
        modalSumelier.textContent = listaVinosActual[index].VINOS.sumilier;
      } else {
        modalSumelier.textContent = listaVinosActual[index].VINOS.sumilierEng;
      }

      if (!baseLink) {
        // Si no hay enlace de tienda, oculta el botón y muestra el comentario
        modalButtonGold.style.display = 'none'; // Ocultar botón
        modalCommentField.textContent =
          comentario ||
          (lenguaje === 'en'
            ? 'Advent Calendar Exclusive'
            : 'Exclusivo del Calendario de Adviento');
        modalCommentField.style.display = 'block'; // Mostrar el comentario
      } else {
        // Si hay enlace, configurar el botón
        modalButtonGold.style.display = 'inline-block'; // Mostrar botón
        modalCommentField.style.display = 'none'; // Ocultar el comentario

        if (baseLink.startsWith('https://') || baseLink.startsWith('http://')) {
          // Si el enlace es absoluto
          modalButtonGold.href =
            lenguaje === 'en'
              ? baseLink.replace(
                  'https://raicesibericas.com/',
                  'https://raicesibericas.com/en/'
                )
              : baseLink;
        } else {
          // Si el enlace es relativo
          modalButtonGold.href =
            lenguaje === 'en' ? `/en${baseLink}` : baseLink;
        }
      }

      if (
        pageHandle === 'advent-calendar-2023' ||
        pageHandle === 'adventcalendar'
      ) {
        if (listaVinos[index].VIDEO != '' && lenguaje == 'es') {
          modalVideoIframeArray[0].src = listaVinosActual[index].VIDEO;
        } else if (listaVinos[index].VIDEO_EN != '' && lenguaje == 'en') {
          modalVideoIframeArray[0].src = listaVinosActual[index].VIDEO_EN;
        } else {
          modalAviso.style.display = 'block';
          modalVideoIframeArray[0].src = ''; //https://www.youtube.com/embed/gRW5K4c6jX0
        }
        modalVideoIframeArray[0].style.display = 'none';
        document.querySelector('#video-iframe').style.display = 'flex';
        setTimeout(() => {
          document.querySelector('#video-iframe').style.display = 'none';
          modalVideoIframeArray[0].style.display = 'block';
        }, 1200);
      }

      modalCalendar.style.display = 'block';
      closeIcon.onclick = function () {
        modalCalendar.style.display = 'none';
      };

      closeIcon.addEventListener('click', function () {
        modalCalendar.style.display = 'none';
      });

      window.onclick = function (event) {
        if (event.target == modal) {
          modalCalendar.style.display = 'none';
        }
      };
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  showCalendarModal();
});

let adventHeroTitle = document.querySelector('.advent-title');
let adventSubtitle = document.querySelector('.advent-subtitle');
let adventHeroSubtitle = document.querySelector('#advent-hero-subtitle');
let adventHeroBtn = document.querySelector('.advent-hero-btn');
let adventRationalTitle = document.querySelector(
  '.advent-rational-content-wrapper h2'
);

let sommelierTitle = document.querySelector('#sommelier-title');
let sommelierSubtitle = document.querySelector('#sommelier-subtitle');
let sommelierClose = document.querySelector(
  '.advent-hero-content-wrapper-image-second h3'
);

let openCalendar = document.querySelector('.advent-calendar-header h2');
let openCalendarText = document.querySelector('.advent-calendar-header p');
let cardBackButtonList = document.querySelectorAll('.btn-advent-calendar-card');
let arrayCardBackButton = Array.from(cardBackButtonList);
let modalVideoContainer = document.querySelectorAll(
  '.modal-video-container h2'
);
// let modalButton = document.getElementById("modal-advent-button");
let modalButtonGold = document.getElementById('modal-advent-button-gold');
let arrayModalVideo = Array.from(modalVideoContainer);
let iconListTitle = document.querySelectorAll('.advent-rational-icon-card h2');
let arrayIconListTitle = Array.from(iconListTitle);
let iconListText = document.querySelectorAll('.advent-rational-icon-card p');
let arrayiconListText = Array.from(iconListText);

let YouTubeVideo = document.getElementById('YouTubeVideo2024');

let adventMapTitle = document.querySelector('.advent-map-title');
let adventBannerSectionH2 = document.querySelector('.advent-banner-section h2');
let adventBannerButton = document.querySelector('.advent-banner-section a');

function adventEnglish() {
  document.addEventListener('DOMContentLoaded', function () {
    const path = window.location.pathname;
    if (path == '/en/pages/advent-calendar-2023') {
      adventHeroTitle.textContent = 'The first advent calendar for winelovers';
      adventSubtitle.textContent = 'Raíces Ibéricas presents:';
      adventHeroSubtitle.textContent = 'With 24 TOP sommeliers';
      adventHeroBtn.textContent = 'GET IT';
      adventHeroBtn.href =
        'https://raicesibericas.com/en/products/raices-advent-calendar';
      adventRationalTitle.innerHTML =
        "<h2>This Christmas, you can embark <span style='color: #d2ab67; font-weight: 700;'> on a wine journey with the exclusive Advent Calendar from Raíces Ibéricas </span>: 24 Spanish native grape varieties, single-varietal wines, and premium sommeliers. It’s truly premium!</h2>";
      sommelierTitle.textContent =
        'THE BEST SOMMELIERS ON THE PLANET WILL BE YOUR GUIDES';
      sommelierSubtitle.textContent =
        'Do you want to learn about the origin of Iberian grapes with Tom Ieven - Head Sommelier of HOF van Cleve with 3 Michelin stars and 11th World Best Sommelier 2023? Or have Stephanie Kippes —Head Sommelier at ABaC with 3 Michelin stars— reveal hidden aromas for you? Discover exclusive wine pairings with Haemin Song— Head Sommelier at Shilla Hotels?';
      sommelierClose.textContent =
        "Don't ask Santa for it. Order it from Raíces Ibéricas.";
      openCalendar.textContent = 'OPEN YOUR CALENDAR!';
      openCalendarText.textContent = 'Click on the date to discover each wine.';
      arrayCardBackButton.forEach(
        element => (element.textContent = 'View more')
      );
      //   modalButton.textContent = "View spec sheet"
      modalButtonGold.textContent = 'Get it now';
      arrayModalVideo[0].textContnt =
        'The video will be available from 1 December';
      arrayModalVideo[0].innerHTML =
        'The video will be available from 1 December';
      adventBannerButton.textContent = 'Catch it';
      adventBannerSectionH2.textContent =
        'GET THE MOST HO HO HO ORIGINAL ADVENT CALENDAR';
      adventMapTitle.textContent =
        'DISCOVER THE WINE REGIONS OF THE ADVENT CALENDAR';
      arrayIconListTitle[0].textContent = '24 wines';
      arrayIconListTitle[1].textContent = 'Monovarietal';
      arrayIconListTitle[2].textContent = 'International Sommeliers';
      arrayiconListText[0].textContent =
        'Enjoy a glass each day from different wine regions.';
      arrayiconListText[1].textContent =
        'Savor the character of the most iconic native grapes.';
      arrayiconListText[2].textContent =
        'Discover with experts about our regions or varieties.';
      adventBannerButton.href =
        'https://raicesibericas.com/en/products/raices-advent-calendar';
    }

    if (path == '/en/pages/adventcalendar') {
      adventHeroTitle.textContent =
        'Featuring 22 Spanish varieties + 2 iconic wines, guided by international sommeliers.';
      adventSubtitle.textContent =
        'Raíces Ibéricas Presents its 2024 Advent Calendar';
      adventHeroSubtitle.textContent = '';
      adventHeroBtn.textContent = 'GET IT NOW';
      adventHeroBtn.href =
        'https://raicesibericas.com/en/products/raices-advent-calendar';
      adventRationalTitle.innerHTML =
        "<h2>Travel through <span style='color: #d2ab67; font-weight: 700;'> 10 wine regions of Spain with the Advent Calendar </span> and discover their native varietals. You’ll be guided by world-renowned sommeliers throughout the tastings.</h2>";
      sommelierTitle.textContent =
        'THE BEST SOMMELIERS ON THE PLANET WILL BE YOUR GUIDES';
      sommelierSubtitle.textContent =
        'Ferran Centelles, El Bulli Drinks Manager & Jancis Robinson collaborator, will help you discover the EVA. Rediscover the Godello grape with Shua Ibáñez from Arzak Restaurant***. Let Mencía reveal its secrets with Ruben Struyve from La Table de Maxime Restaurant**. Share a glass of Raíces 1 red with Antonello Nicastri from Flore Restaurant***. Be amazed by the nuances of Hondarrabi with Amaia Soto from The Way We Wine Now.';
      sommelierClose.textContent =
        'Don’t ask Santa for it—ask Raíces Ibéricas.';
      openCalendar.textContent = 'OPEN YOUR CALENDAR!';
      openCalendarText.textContent =
        'Click on each date to discover each wine.';
      arrayCardBackButton.forEach(
        element => (element.textContent = 'View more')
      );
      //     modalButton.textContent = "View spec sheet"
      modalButtonGold.textContent = 'Get it now';
      arrayModalVideo[0].textContnt =
        'The video will be available from 1 December';
      arrayModalVideo[0].innerHTML =
        'The video will be available from 1 December';
      adventBannerButton.textContent = 'GRAB IT NOW';
      adventBannerSectionH2.textContent =
        'GET YOUR ADVENT CALENDAR NOW - MADE FOR TRUE WINE LOVERS';
      adventMapTitle.textContent =
        "DISCOVER THE WINE REGIONS YOU'LL TRAVEL TO WITH THE 2024 ADVENT CALENDAR";
      arrayIconListTitle[0].textContent = '24 wines';
      arrayIconListTitle[1].textContent = 'Monovarietal';
      arrayIconListTitle[2].textContent = 'International Sommeliers';
      arrayiconListText[0].textContent =
        'Enjoy a glass each day from different wine regions.';
      arrayiconListText[1].textContent =
        'The best of each area and its iconic grapes.';
      arrayiconListText[2].textContent =
        'Luxury tasting guides to complete the experience.';
      adventBannerButton.href =
        'https://raicesibericas.com/en/products/raices-advent-calendar';
      YouTubeVideo.src = 'https://www.youtube.com/embed/DZKuZzzOflw';
    }
  });
}

adventEnglish();
